import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '../../../component/Icon';
import Portal from '../../../component/Portal';
import { renderCount } from '../../../util-lib/discount-headline';
import './style.scss';

const Bar = (
  {
    viewCount, likeCount, directUrl, isLiked,
    onShare, onLike, onUnlike
  }
) => {
  return (
    <Portal>
      <article
        className="bar"
      >
        <section className={cx('bar-wrapper', directUrl ? 'has-direct-url' : '')}>
          <div className="tool">
            <div className="tool-item">
              <div className="tool-item-icon">
                <Icon name="eye" className="icon-eye" />
              </div>
              <p>{renderCount(viewCount)}</p>
            </div>
            <div className="tool-item" onClick={isLiked ? onUnlike : onLike}>
              <div className="tool-item-icon">
                {
                  isLiked ? (
                    <Icon name="liked" className="icon-liked" />
                  ) : (
                    <Icon name="like" className="icon-like" />
                  )
                }
              </div>
              <p>{renderCount(likeCount)}</p>
            </div>
            <div className="tool-item" onClick={onShare}>
              <div className="tool-item-icon">
                {
                  isLiked ? (
                    <Icon name="wechat" className="icon-wechat" />
                  ) : (
                    <Icon name="share" className="icon-share" />
                  )
                }
              </div>
            </div>
          </div>
          {
            !!directUrl && (
              <div
                className="link is-active"
                onClick={() => { window.location.href = directUrl; }}
              >
                直达链接
              </div>
            )
          }
        </section>
      </article>
    </Portal>
  );
};

Bar.propTypes = {
  // shareCount: PropTypes.number,
  viewCount: PropTypes.number,
  likeCount: PropTypes.number,
  directUrl: PropTypes.string,
  isLiked: PropTypes.bool,
  onShare: PropTypes.func,
  onLike: PropTypes.func,
  onUnlike: PropTypes.func
};

export default Bar;
